export default {
  common: {
    all: '全部',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    logout: '退出登录',
    login: '登录',
    username: '用户名',
    password: '密码',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    status: '状态',
    action: '操作',
    detail: '详情',
    export: '导出',
    import: '导入',
    upload: '上传',
    download: '下载',
    view: '查看',
    add: '添加',
    close: '关闭',
    language: '语言',
    loading: '加载中...',
    noData: '暂无数据',
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示',
    total: '共',
    items: '条',
    today: '今日',
    days: '天',
    amount: '金额',
    createTime: '创建时间',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    distribution: '分布'
  },
  login: {
    title: '老屋医生',
    subtitle: '专业的老屋维修解决方案',
    roleAdmin: '管理员',
    roleAdministrative: '行政',
    username: '用户名',
    password: '密码',
    rememberMe: '记住我',
    loginButton: '登录',
    loggingIn: '登录中...',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    usernameRequired: '请输入用户名',
    passwordRequired: '请输入密码',
    invalidCredentials: '用户名或密码错误',
    accountDisabled: '账号已被禁用',
    networkError: '网络错误，请稍后重试',
    languagePreference: '语言偏好'
  },
  nav: {
    dashboard: '仪表盘',
    appointment: '预约管理',
    order: '订单管理',
    customer: '客户管理',
    store: '门店管理',
    staff: '员工管理',
    material: '材料管理',
    finance: '财务管理',
    statistics: '统计报表',
    referrerStatistics: '介绍人统计',
    priceTemplate: '报价单模板',
    notification: '通知中心',
    profile: '个人中心',
    adminManagement: '管理员管理'
  },
  appointment: {
    title: '预约',
    list: '预约列表',
    detail: '预约详情',
    create: '创建预约',
    email: '邮箱',
    name: '姓名',
    phone: '电话',
    address: '地址',
    lineId: 'Line ID',
    isUrgent: '是否紧急',
    urgent: '紧急',
    repairType: '修缮类型',
    description: '补充说明',
    images: '图片集',
    otherRequirements: '其他需求说明',
    howKnow: '如何得知老屋医生',
    referrerPhone: '介绍人手机号',
    referrerStore: '介绍店家',
    joinedMember: '是否加入老屋医生',
    normal: '普通',
    yes: '是',
    no: '否',
    generateWorkOrder: '生成报修单',
    assignStore: '指派门店',
    // 统计
    totalCount: '总预约数',
    pendingCount: '待处理',
    urgentCount: '紧急预约',
    // 搜索
    region: '地区',
    regionPlaceholder: '请输入地区',
    statusPlaceholder: '请选择',
    // 状态
    pending: '待处理',
    converted: '已转换',
    cancelled: '已取消',
    pending_review: '待审核',
    pending_technician: '待分配师傅',
    quoted: '已报价',
    material_preparing: '备料中',
    pending_construction: '待施工',
    constructing: '施工中',
    pending_acceptance: '待验收',
    acceptance: '验收中',
    completed: '已完成',
    closed: '已结案',
    // 操作
    cancel: '取消',
    cancelConfirm: '确定要取消此预约吗？',
    cancelSuccess: '取消成功',
    cancelFailed: '取消失败',
    deleteConfirm: '确定要删除此预约吗？此操作不可恢复！',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    fetchListFailed: '获取预约列表失败',
    fetchDetailFailed: '获取预约详情失败',
    // 详情
    reservationId: '预约ID',
    sourceChannel: '来源渠道',
    recommenderName: '推荐人姓名',
    updateTime: '更新时间',
    caseNo: '案件编号',
    currentStage: '当前阶段',
    storeName: '门店名称',
    surveyorName: '勘查师傅',
    constructorName: '施工师傅',
    surveyTime: '勘查时间',
    customerDemand: '客户需求',
    otherDemand: '其他需求',
    // 阶段信息
    orderDemand: '订单需求',
    quotationStage: '报价信息',
    materialStage: '备料信息',
    constructionStage: '施工信息',
    acceptanceStage: '验收信息',
    // 报价
    quotedAmount: '报价金额',
    quotationDesc: '报价说明',
    totalApprovedAmount: '已批准总金额',
    quotationTime: '报价时间',
    quoterName: '报价人',
    approverName: '审批人',
    approvalTime: '审批时间',
    // 备料
    materialName: '材料名称',
    materialPrice: '材料价格',
    prepareTime: '备料时间',
    preparerName: '备料人',
    // 施工
    constructionDate: '施工日期',
    beforeRecords: '施工前',
    duringRecords: '施工中',
    afterRecords: '施工后',
    recordTime: '记录时间',
    recorderName: '记录人',
    // 验收
    completionDate: '完成日期',
    chargeAmount: '收费金额',
    acceptanceDate: '验收日期',
    paymentMethod: '支付方式',
    collectionAmount: '收款金额',
    acceptorName: '验收人',
    customerConfirm: '客户确认',
    customerSignature: '客户签名',
    remark: '备注',
    noData: '暂无数据',
    adminRemark: '管理员备注',
    noRemark: '暂无备注',
    remarkPlaceholder: '请输入备注内容...',
    remarkSaveSuccess: '备注保存成功',
    remarkSaveFailed: '备注保存失败',
    // 导出和打印
    allStatus: '全部状态',
    allUrgent: '全部',
    exportExcel: '导出Excel',
    exportingExcel: '正在导出Excel，请稍候...',
    noDataToExport: '没有数据可导出',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    exportTip: '如果不选择任何条件，将导出所有数据（包括所有分页）',
    print: '打印',
    order: '订单',
    basicInfo: '基本信息',
    orderDetail: '订单详情',
    generatingPDF: '正在生成PDF，请稍候...',
    printSuccess: '打印成功',
    printFailed: '打印失败'
  },
  customer: {
    title: '客户管理',
    list: '客户列表',
    detail: '客户详情',
    // 统计
    totalCount: '总客户数',
    activeCount: '启用客户',
    inactiveCount: '禁用客户',
    todayNewCount: '今日新增',
    // 基本信息
    customerId: '客户ID',
    username: '用户名',
    realName: '姓名',
    phone: '电话',
    email: '邮箱',
    lineId: 'LINE ID',
    address: '地址',
    regionText: '区域',
    orderCount: '订单数',
    status: '状态',
    enabled: '启用',
    disabled: '禁用',
    createTime: '创建时间',
    // 订单统计
    orderStats: '订单统计',
    totalOrderCount: '总订单数',
    totalAmount: '总消费金额',
    pendingCount: '待分配',
    preparingCount: '备料中',
    constructingCount: '施工中',
    acceptanceCount: '验收中',
    completedCount: '已完成',
    cancelledCount: '已取消',
    // 评价统计
    reviewStats: '评价统计',
    totalReviewCount: '评价总数',
    avgRating: '平均评分',
    orderId: '订单ID',
    rating: '评分',
    reviewContent: '评价内容',
    reviewerName: '评价人',
    reviewerPhone: '评价人电话',
    reviewTime: '评价时间',
    noReviews: '暂无评价',
    // 操作
    view: '查看',
    edit: '编辑',
    enable: '启用',
    disable: '冷宫',
    delete: '删除',
    // 表单
    editCustomer: '编辑客户',
    pleaseEnterName: '请输入客户姓名',
    pleaseEnterPhone: '请输入联系电话',
    pleaseEnterEmail: '请输入邮箱地址',
    pleaseEnterCorrectEmail: '请输入正确的邮箱地址',
    phoneFormatError: '电话号码必须为10位数字',
    // 确认消息
    enableConfirm: '确定要启用客户',
    disableConfirm: '确定要将客户打入冷宫',
    deleteConfirm: '确定要删除客户',
    deleteWarning: '此操作不可恢复！',
    // 导出
    allStatus: '全部状态',
    exportExcel: '导出Excel',
    exportingExcel: '正在导出Excel，请稍候...',
    noDataToExport: '没有数据可导出',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    exportTip: '如果不选择任何条件，将导出所有数据（包括所有分页）',
    // 成功消息
    enableSuccess: '启用成功',
    disableSuccess: '已打入冷宫',
    deleteSuccess: '删除成功',
    updateSuccess: '更新成功',
    // 失败消息
    enableFailed: '启用失败',
    disableFailed: '打入冷宫失败',
    deleteFailed: '删除失败',
    updateFailed: '更新失败',
    fetchListFailed: '获取客户列表失败',
    fetchDetailFailed: '获取客户详情失败',
    basicInfo: '基本信息',
    remark: '备注',
    noRemark: '暂无备注',
    remarkPlaceholder: '请输入备注内容...',
    remarkSaveSuccess: '备注保存成功',
    remarkSaveFailed: '备注保存失败',
    editRemark: '编辑备注'
  },
  workOrder: {
    title: '报修单',
    list: '报修单列表',
    detail: '报修单详情',
    create: '创建报修单',
    caseNumber: '案件编号',
    inProgress: '进行中报修单',
    customerInfo: '客户资料',
    customerName: '客户姓名',
    phone: '联系电话',
    surveyPerson: '场勘负责人',
    region: '地区',
    surveyDate: '场勘日期',
    detailAddress: '详细地址',
    constructionPerson: '施工负责人',
    building: '大楼',
    constructionDate: '施工日期',
    repairType: '修缮类型',
    customerRequirement: '客户需求',
    surveyResult: '场勘结果',
    chargeAmount: '收费金额',
    customerSignature: '客户签名',
    construction: '施工',
    constructionRecord: '施工记录',
    completionRecord: '完工记录',
    closure: '结案',
    completionDate: '完工日期',
    paymentDate: '收款日期',
    closureDate: '结案日期',
    engineeringLeader: '工程组长',
    accountingLeader: '会计组长',
    supervisorApproval: '主管审核',
    pending: '待处理',
    completed: '已完成',
    closed: '已结案'
  },
  material: {
    title: '材料备料',
    list: '材料列表',
    name: '材料名称',
    price: '材料价格',
    quantity: '数量',
    totalPrice: '总价',
    uploadImage: '上传图片',
    addMaterial: '添加材料'
  },
  construction: {
    title: '施工管理',
    before: '施工前',
    during: '施工中',
    after: '施工后',
    uploadPhotos: '上传照片',
    createSubOrder: '创建子订单',
    subOrder: '子订单'
  },
  acceptance: {
    title: '验收',
    paymentMethod: '收款方式',
    cash: '现金',
    transfer: '汇款',
    amount: '金额',
    signature: '客户签名',
    complete: '完成验收'
  },
  finance: {
    title: '财务管理',
    totalRevenue: '总收入',
    todayRevenue: '今日收入',
    monthRevenue: '本月收入',
    completedOrders: '已完成订单',
    averageOrderValue: '平均订单金额',
    cancelledOrders: '已取消订单',
    searchKeyword: '搜索案件编号、客户姓名、电话',
    allStores: '全部门店',
    createStartDate: '创建开始日期',
    createEndDate: '创建结束日期',
    caseNo: '案件编号',
    customerName: '客户姓名',
    phone: '电话',
    email: '邮箱',
    lineId: 'Line ID',
    address: '地址',
    storeName: '门店名称',
    repairType: '修缮类型',
    chargeAmount: '收费金额',
    surveyorName: '勘察人员',
    constructorName: '施工人员',
    constructionDate: '施工日期',
    completionDate: '完工日期',
    orderDetail: '订单详情',
    paymentStatus: '回款状态',
    paid: '已回款',
    unpaid: '未回款',
    overdue: '逾期',
    overdueWarning: '超期预警',
    paymentRecord: '收款记录',
    closed: '已结案',
    cancelled: '已取消',
    exportExcel: '导出Excel',
    exportingExcel: '正在导出Excel，请稍候...',
    noDataToExport: '没有数据可导出',
    pleaseEnterCustomerName: '请输入客户姓名',
    createTimeRange: '创建时间范围',
    exportTip: '如果不选择任何条件，将导出所有数据（包括所有分页）'
  },
  followUp: {
    title: '售后回访',
    list: '回访列表',
    create: '创建回访',
    callCustomer: '致电客户',
    feedback: '客户反馈',
    satisfaction: '满意度',
    verySatisfied: '非常满意',
    satisfied: '满意',
    neutral: '一般',
    dissatisfied: '不满意'
  },
  store: {
    title: '门店管理',
    list: '门店列表',
    name: '门店名称',
    storeId: '门店ID',
    manager: '店长',
    managerPhone: '店长电话',
    address: '门店地址',
    detailAddress: '详细地址',
    contactPhone: '联系电话',
    businessHours: '营业时间',
    createTime: '创建时间',
    status: '状态',
    active: '营业中',
    inactive: '已停业',
    totalStores: '总门店数',
    activeStores: '营业中',
    inactiveStores: '已停业',
    allStatus: '全部状态',
    pleaseEnterStoreName: '请输入门店名称',
    pleaseEnterAddress: '请输入地址',
    enable: '启用',
    disable: '停用',
    exportExcel: '导出Excel',
    exportingExcel: '正在导出Excel，请稍候...',
    noDataToExport: '没有数据可导出',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    exportTip: '如果不选择任何条件，将导出所有数据（包括所有分页）',
    // 抽成设置
    commissionSettings: '抽成设置',
    commissionTip: '设置不同级别门店的抽成比例，级别越高抽成越低',
    storeLevel: '门店级别',
    levelName: '级别名称',
    commissionRate: '抽成比例',
    setLevel: '设置级别',
    currentLevel: '当前级别',
    newLevel: '新级别',
    remark: '备注',
    editRemark: '编辑备注',
    remarkPlaceholder: '请输入备注内容...',
    remarkSaveSuccess: '备注保存成功',
    remarkSaveFailed: '备注保存失败'
  },
  staff: {
    title: '员工管理',
    list: '员工列表',
    name: '姓名',
    username: '用户名',
    realName: '真实姓名',
    role: '角色',
    phone: '电话',
    email: '邮箱',
    store: '所属门店',
    status: '状态',
    password: '密码',
    technicianLevel: '技师等级',
    lastLoginTime: '最后登录',
    // 角色
    admin: '管理员',
    administrative: '行政',
    storeManager: '店长',
    technician: '师傅',
    // 状态
    active: '在职',
    inactive: '离职',
    // 操作
    add: '新增员工',
    edit: '编辑员工',
    detail: '员工详情',
    delete: '删除员工',
    view: '查看',
    changeRole: '切换角色',
    resetPassword: '重置密码',
    remark: '备注',
    editRemark: '编辑备注',
    remarkPlaceholder: '请输入备注内容...',
    remarkSaveSuccess: '备注保存成功',
    remarkSaveFailed: '备注保存失败',
    // 统计
    totalEmployees: '总员工数',
    adminCount: '管理员',
    administrativeCount: '行政人员',
    storeManagerCount: '店长',
    technicianCount: '师傅',
    activeCount: '在职',
    inactiveCount: '离职',
    // 搜索
    searchKeyword: '搜索姓名、手机号、邮箱',
    allRoles: '全部角色',
    allStatus: '全部状态',
    allStores: '全部门店',
    // 导出
    exportExcel: '导出Excel',
    exportingExcel: '正在导出Excel，请稍候...',
    noDataToExport: '没有数据可导出',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    exportTip: '如果不选择任何条件，将导出所有数据（包括所有分页）',
    // 详情
    employeeInfo: '员工信息',
    storeInfo: '门店信息',
    region: '地区',
    workStats: '工作统计',
    totalOrders: '总订单数',
    completedOrders: '已完成',
    inProgressOrders: '进行中',
    // 评价统计
    reviewStats: '评价统计',
    totalReviewCount: '评价总数',
    avgRating: '平均评分',
    reviewDetails: '评价详情',
    orderId: '订单ID',
    rating: '评分',
    reviewContent: '评价内容',
    reviewerName: '评价人',
    reviewerPhone: '评价人电话',
    reviewTime: '评价时间',
    noReviews: '暂无评价'
  },
  managerApplication: {
    title: '店长申请审核',
    totalApplications: '总申请数',
    pending: '待审核',
    approved: '已通过',
    rejected: '已拒绝',
    applicant: '申请人',
    phone: '联系电话',
    email: '邮箱',
    lineId: 'Line ID',
    region: '地区',
    viewDetail: '查看详情',
    approve: '通过',
    reject: '拒绝',
    applicationDetail: '申请详情',
    applicationId: '申请ID',
    applicationStatus: '申请状态',
    reason: '申请理由',
    applicationTime: '申请时间',
    reviewTime: '审核时间',
    reviewer: '审核人',
    assignedStore: '分配门店',
    reviewComment: '审核意见',
    approveTitle: '审核通过',
    rejectTitle: '审核拒绝',
    note: '说明',
    approveNote: '审核通过后将自动为该申请人创建新门店，门店名称默认为"{name}的门店"，店长可后续自行修改。',
    reviewCommentPlaceholder: '请输入审核意见（可选）',
    confirmApprove: '确认通过',
    rejectReason: '拒绝理由',
    rejectReasonPlaceholder: '请输入拒绝理由',
    confirmReject: '确认拒绝',
    fetchDetailFailed: '获取申请详情失败',
    approveSuccess: '审核通过成功，已自动创建门店',
    approveFailed: '审核失败',
    pleaseEnterRejectReason: '请输入拒绝理由',
    rejectSuccess: '已拒绝申请'
  },
  notification: {
    title: '通知中心',
    newAppointment: '新预约通知',
    workOrderAssigned: '报修单已指派',
    taskAssigned: '任务已指派',
    paymentOverdue: '回款逾期提醒',
    markAsRead: '标记为已读',
    markAllAsRead: '全部标记为已读',
    // WebSocket 通知
    drawerTitle: '预约通知',
    unreadCount: '{count} 条未读通知',
    markAllRead: '全部标记为已读',
    noNotifications: '暂无通知',
    viewDetail: '查看详情',
    urgent: '紧急',
    justNow: '刚刚',
    minutesAgo: '{minutes}分钟前',
    hoursAgo: '{hours}小时前',
    daysAgo: '{days}天前',
    allMarkedRead: '已全部标记为已读',
    connectionFailed: '连接失败',
    websocketConnectionFailed: 'WebSocket连接失败，请刷新页面重试'
  },
  dashboard: {
    title: '仪表盘',
    overview: '数据概览',
    todayAppointment: '今日预约',
    pendingWorkOrder: '待处理报修单',
    inProgressWorkOrder: '进行中报修单',
    completedWorkOrder: '已完成报修单',
    totalRevenue: '总收入',
    monthlyRevenue: '本月收入',
    customerSatisfaction: '客户满意度',
    recentAppointments: '最近预约',
    recentWorkOrders: '最近报修单',
    statistics: '统计图表'
  },
  statistics: {
    title: '统计报表',
    selectStore: '选择门店',
    allStores: '全部门店',
    totalOrders: '总订单数',
    totalRevenue: '总收入',
    totalCustomers: '总客户数',
    completionRate: '完成率',
    closedOrders: '已结案订单',
    cancelledOrders: '已取消订单',
    averageOrderValue: '平均订单金额',
    todayOrders: '今日订单',
    todayRevenue: '今日收入',
    monthOrders: '本月订单',
    monthRevenue: '本月收入',
    newCustomers: '新客户',
    returningCustomers: '回头客',
    returningRate: '回头率',
    orderTrend: '订单趋势',
    byDay: '按天',
    byWeek: '按周',
    byMonth: '按月',
    last7Days: '最近7天',
    last14Days: '最近14天',
    last30Days: '最近30天',
    // 图表标题
    orderStatusDistribution: '订单状态分布',
    urgentOrders: '紧急订单',
    repairTypeDistribution: '修缮类型分布',
    revenueStats: '收入统计',
    storeRanking: '门店业绩排行',
    technicianRanking: '师傅业绩排行',
    regionDistribution: '地区分布',
    // 修缮类型收入分析
    repairTypeRevenueAnalysis: '修缮类型收入分析',
    revenuePercentage: '收入占比',
    revenueShare: '收入份额',
    averagePrice: '平均单价',
    // 客户来源分析
    customerSourceAnalysis: '客户来源分析',
    referralOrders: '介绍订单',
    referralRate: '转介绍率',
    channelCount: '渠道数量',
    recommenderCount: '介绍人数量',
    channelAnalysis: '来源渠道分析',
    sourceChannel: '来源渠道',
    recommenderAnalysis: '介绍人分析',
    recommenderName: '介绍人姓名',
    recommenderPhone: '介绍人电话',
    recommenderStore: '介绍店家',
    noRecommenderData: '暂无介绍人数据',
    // 订单处理时间分析
    processingTimeAnalysis: '订单处理时间分析',
    completedOrders: '已完成订单',
    averageDays: '平均天数',
    minDays: '最短天数',
    maxDays: '最长天数',
    medianDays: '中位数天数',
    timeDistribution: '处理时间分布',
    typeProcessingTime: '各类型处理时间',
    days: '天',
    year: '年',
    top3: '前3名',
    top5: '前5名',
    top10: '前10名',
    orderCount: '订单数',
    revenue: '收入',
    percentage: '占比',
    exportPDF: '导出PDF',
    exportingPDF: '正在生成PDF，请稍候...',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    // 收入统计
    averageMonthlyRevenue: '月均收入',
    highestMonth: '最高月份',
    lowestMonth: '最低月份',
    // 排行榜
    rank: '排名',
    storeName: '门店名称',
    manager: '店长',
    technicianName: '师傅姓名',
    level: '等级',
    satisfaction: '满意度',
    repairType: '修缮类型',
    displayPercentage: '百分比',
    displayCount: '数量',
    displayBoth: '两者'
  },
  administrativeDashboard: {
    title: '行政工作台',
    // 统计卡片
    todayNewReservations: '今日新预约',
    urgentCases: '紧急案件',
    pendingStoreAssignment: '待分配门店',
    pendingFollowUp: '待回访',
    // 待处理订单
    pendingOrdersTitle: '待处理订单',
    searchPlaceholder: '搜索客户姓名/电话',
    viewAll: '查看全部',
    orderNumber: '订单编号',
    tags: '标签',
    priority: '优先级',
    urgent: '紧急',
    customerName: '客户姓名',
    contactPhone: '联系电话',
    repairType: '修缮类型',
    region: '地区',
    surveyDate: '勘查日期',
    timeSlot: '时段',
    waitingHours: '等待时长',
    assignedStore: '分配门店',
    view: '查看',
    assignStore: '分配门店',
    // 优先级
    high: '高',
    medium: '中',
    low: '低',
    urgentTag: '急',
    // 订单详情
    orderDetail: '订单详情',
    notGenerated: '未生成',
    isUrgent: '是否紧急',
    normal: '正常',
    problemDescription: '问题描述',
    none: '无',
    confirmOrderSuccess: '接单成功',
    // 日历
    weeklyCalendar: '本周订单日历',
    viewFullCalendar: '查看完整日历',
    orders: '单'
  },
  administrativeAppointments: {
    title: '预约管理',
    searchPlaceholder: '搜索姓名/电话/邮箱',
    repairType: '修缮类型',
    search: '搜索',
    reset: '重置',
    // 表格列
    reservationId: '预约ID',
    caseNo: '案例编号',
    urgent: '紧急',
    urgentTag: '急',
    customerName: '客户姓名',
    contactPhone: '联系电话',
    email: '邮箱',
    lineId: 'LINE ID',
    address: '地址',
    repairTypeLabel: '修缮类型',
    supplementDesc: '补充说明',
    sourceChannel: '如何得知',
    recommenderName: '介绍人',
    joinLineGroup: '加入LINE群',
    yes: '是',
    no: '否',
    images: '图片',
    noImages: '无',
    // 操作
    confirmOrder: '确认接单',
    assignStore: '分配门店',
    cancel: '取消',
    // 修缮类型选项
    waterType: '水类',
    electricType: '电类',
    leakage: '漏水',
    comprehensive: '综合',
    bathEquipment: '沐浴设备',
    other: '其他',
    // 分配门店
    reservationInfo: '预约信息',
    selectStore: '选择门店',
    searchStorePlaceholder: '搜索门店名称/店长名/手机号',
    active: '启用',
    inactive: '停用',
    businessHours: '营业时间',
    storePhone: '门店电话',
    manager: '店长',
    confirmAssign: '确认分配',
    pleaseSelectStore: '请选择门店',
    assignStoreSuccess: '门店分配成功',
    assignStoreFailed: '门店分配失败',
    fetchStoreListFailed: '获取门店列表失败'
  },
  administrativeOrders: {
    title: '订单管理',
    customerName: '客户姓名',
    customerPhone: '客户电话',
    caseNo: '案例编号',
    orderStatus: '订单状态',
    onlyUrgent: '仅紧急',
    search: '搜索',
    reset: '重置',
    urgent: '紧急',
    urgentTag: '急',
    address: '地址',
    repairType: '修缮类型',
    assignedStore: '分配门店',
    assignStore: '分配门店',
    orderDetail: '订单详情',
    close: '关闭',
    // 订单状态
    pending: '待分配',
    quoted: '已报价',
    materialPreparing: '备料中',
    constructing: '施工中',
    acceptance: '验收中',
    completed: '已完成',
    closed: '已结案',
    cancelled: '已取消',
    // 订单详情阶段
    orderDemandStage: '订单需求',
    quotationStage: '报价阶段',
    materialStage: '备料阶段',
    constructionStage: '施工阶段',
    acceptanceStage: '验收阶段',
    reviewStage: '评价阶段',
    // 订单需求字段
    reservationId: '预约ID',
    realName: '客户姓名',
    phone: '联系电话',
    regionText: '地区',
    supplementDesc: '补充说明',
    customerDemand: '客户需求',
    customerUploadMedia: '客户上传媒体',
    // 报价阶段
    totalAmount: '总金额',
    mainQuotation: '主报价',
    subQuotation: '追加报价',
    quotationType: '报价类型',
    quotedAmount: '报价金额',
    quotedTime: '报价时间',
    workDescription: '工作描述',
    approved: '已批准',
    // 备料阶段
    materialName: '材料名称',
    materialPrice: '价格',
    prepareTime: '备料时间',
    images: '图片',
    // 施工阶段
    constructionDate: '施工日期',
    beforeConstruction: '施工前',
    duringConstruction: '施工中',
    afterConstruction: '施工后',
    createTime: '创建时间',
    stageDesc: '阶段描述',
    // 验收阶段
    completionDate: '完工日期',
    acceptanceDate: '验收日期',
    chargeAmount: '收费金额',
    collectionAmount: '收款金额',
    paymentMethod: '付款方式',
    customerConfirm: '客户确认',
    confirmed: '已确认',
    notConfirmed: '未确认',
    acceptanceImages: '验收图片',
    customerSignature: '客户签名',
    // 评价阶段
    customerToTechnician: '客户对师傅的评价',
    technicianToCustomer: '师傅对客户的评价',
    reviewed: '已评价',
    notReviewed: '未评价',
    rating: '评分',
    reviewContent: '评价内容',
    reviewerName: '评价人',
    reviewTime: '评价时间',
    noReview: '暂无评价',
    technicianAvgRating: '师傅平均评分',
    customerAvgRating: '客户平均评分',
    reviewCount: '条评价'
  },
  priceTemplate: {
    title: '报价单模板管理',
    categoryManagement: '分类管理',
    templateList: '报价模板列表',
    addCategory: '新增分类',
    editCategory: '编辑分类',
    addTemplate: '新增模板',
    editTemplate: '编辑模板',
    categoryName: '分类名称',
    repairType: '修缮类型',
    itemName: '项目名称',
    price: '价格',
    pricePlaceholder: '例如：$800~$1500/个',
    remark: '备注',
    sortOrder: '排序',
    enabled: '启用',
    disabled: '禁用',
    searchPlaceholder: '搜索项目名称、备注',
    pleaseEnterCategoryName: '请输入分类名称',
    pleaseCompleteForm: '请填写完整信息',
    deleteCategoryConfirm: '确定要删除此分类吗？',
    deleteTemplateConfirm: '确定要删除此模板吗？'
  },
  referrer: {
    title: '介绍人统计',
    // 概览
    totalReferrals: '总介绍订单数',
    totalReferrers: '总介绍人数',
    completedCount: '已完成订单数',
    totalRevenue: '总收入金额',
    completionRate: '完成率',
    monthReferrals: '本月介绍订单',
    monthReferrers: '本月介绍人数',
    // 排行榜
    ranking: '介绍人排行榜',
    sortByReferralCount: '按介绍数排序',
    sortByRevenue: '按收入排序',
    sortByCompletedCount: '按完成数排序',
    sortByName: '按姓名排序',
    // 列表
    list: '介绍人列表',
    searchPlaceholder: '搜索介绍人姓名',
    referrerName: '介绍人姓名',
    referralCount: '介绍订单数',
    revenue: '收入',
    firstReferralDate: '首次介绍日期',
    lastReferralDate: '最近介绍日期',
    // 详情
    detail: '介绍人详情',
    orderList: '介绍订单列表',
    caseNo: '案件编号',
    customerName: '客户姓名',
    phone: '电话',
    address: '地址',
    repairType: '修缮类型',
    status: '状态',
    chargeAmount: '收费金额',
    createTime: '创建时间',
    fetchDetailFailed: '获取详情失败',
    // 状态
    statusPending: '待分配',
    statusMaterialPreparing: '备料中',
    statusConstructing: '施工中',
    statusAcceptance: '验收中',
    statusCompleted: '已完成',
    statusClosed: '已结案',
    statusCancelled: '已取消'
  },
  adminManagement: {
    title: '管理员管理',
    add: '新增管理员',
    edit: '编辑管理员',
    detail: '管理员详情',
    userId: '用户ID',
    username: '用户名',
    realName: '真实姓名',
    phone: '手机号',
    email: '邮箱',
    roleType: '角色类型',
    admin: '管理员',
    administrative: '行政',
    enabled: '启用',
    disabled: '禁用',
    lastLoginTime: '最后登录',
    currentPassword: '当前密码',
    newPassword: '新密码',
    password: '密码',
    allStatus: '全部状态',
    // 占位符
    currentPasswordPlaceholder: '请输入当前管理员密码',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    newPasswordPlaceholder: '留空则不修改密码',
    realNamePlaceholder: '请输入真实姓名',
    phonePlaceholder: '请输入手机号',
    emailPlaceholder: '请输入邮箱',
    roleTypePlaceholder: '请选择角色类型',
    // 提示
    currentPasswordTip: '为了安全，所有操作都需要验证当前管理员密码',
    // 验证
    currentPasswordRequired: '请输入当前密码',
    usernameRequired: '请输入用户名',
    passwordRequired: '请输入密码',
    passwordMinLength: '密码至少6位',
    realNameRequired: '请输入真实姓名',
    phoneRequired: '请输入手机号',
    phoneFormatError: '手机号格式错误',
    emailFormatError: '邮箱格式错误',
    roleTypeRequired: '请选择角色类型',
    // 消息
    createSuccess: '创建成功',
    updateSuccess: '更新成功',
    deleteSuccess: '删除成功',
    deleteConfirm: '确定要删除管理员 {name} 吗？',
    cannotDeleteSelf: '不能删除自己的账号',
    fetchListFailed: '获取列表失败',
    fetchDetailFailed: '获取详情失败'
  }
}
